<template>
  <div v-if="importQueues.length" class="import-queue-list">
    <el-table :data="filteredImportQueues" style="width: 100%">
      <el-table-column
        v-for="column in importQueueColumns"
        :key="column.prop"
        :prop="column.prop"
        :label="column.label"
        :width="column.width"
      >
        <!--            <template slot="header" slot-scope="scope">-->
        <!--              <div class="d-grid">-->
        <!--                <div>{{ column.label }}</div>-->
        <!--                <input class="el-input__inner" type="text" :placeholder="fromPlaceholder" v-model="importQueueFilter[column.prop].from">-->
        <!--                <input class="el-input__inner" type="text" :placeholder="toPlaceholder" v-model="importQueueFilter[column.prop].to">-->
        <!--              </div>-->
        <!--            </template>-->
        <template slot-scope="scope">
          <el-progress
            v-if="column.prop === 'progress'"
            :percentage="scope.row['progress']"
            :status="scope.row.failedCount ? 'warning' : 'success'"
          />
          <a
            v-else-if="showDownload(column, scope.row[column.prop])"
            href="javascript:void(0)"
            @click="download(scope.row)"
            class="d-flex dropdown-link"
          >
            {{ scope.row[column.prop] }}
            <span class="material-icons">file_download</span>
          </a>
          <div v-else>{{ scope.row[column.prop] }}</div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { get } from 'lodash'
import mixinNotify from '../../utils/mixin-notify'

const dateTimeFormat = 'YYYY-MM-DD HH:mm'

export default {
  name: 'ImportQueueList',
  mixins: [mixinNotify],
  props: {
    importId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      importQueues: [],
      importQueueFilter: {
        id: { from: '', to: '' },
        progress: { from: '', to: '' },
        rows: { from: '', to: '' },
        successCount: { from: '', to: '' },
        failedCount: { from: '', to: '' },
      },
      fromPlaceholder: this.$i18n.t(`number_interval_from`),
      toPlaceholder: this.$i18n.t(`number_interval_to`),
      importQueueColumns: [
        {
          label: this.$i18n.t('import_filename'),
          prop: 'fileName',
          width: 400,
        },
        {
          label: this.$i18n.t('queue_progress'),
          prop: 'progress',
          width: 250,
        },
        { label: this.$i18n.t('job_rows'), prop: 'rows', width: 150 },
        {
          label: this.$i18n.t('successful_rows'),
          prop: 'successCount',
          width: 150,
        },
        {
          label: this.$i18n.t('failed_rows'),
          prop: 'failedCount',
          width: 150,
        },
        { label: this.$i18n.t('created_at'), prop: 'createdAt', width: 200 },
      ],
    }
  },
  computed: {
    filteredImportQueues() {
      return this.importQueues
      /*return this.importQueues.filter(queue => {
                let hit = true
                for (const prop of Object.keys(this.importQueueFilter)) {
                  const filter = this.importQueueFilter[prop]
                  if (filter.from && queue[prop] < +filter.from) hit = false
                  if (filter.to && queue[prop] > +filter.to) hit = false
                }
                return hit
              })*/
    },
  },
  watch: {
    async progressCount(newValue, oldValue) {
      if (newValue !== oldValue) {
        await this.getData()
      }
    },
  },
  methods: {
    showDownload(col, failedCount) {
      return col.prop === 'failedCount' && failedCount
    },
    downloadErrorFile(parameters) {
      return this.$client.execute({
        operationId: 'Dynform_importResult',
        method: 'get',
        parameters,
      })
    },
    async download(data) {
      const regex = /\.([0-9a-z]+$)/i // @regex get extension from fileName
      const match = data.fileName.match(regex)
      const parameters = {
        importId: data.importId,
        extension: match[1],
      }

      this.downloadErrorFile(parameters).then(({ body }) => {
        if (!body || get(body, 'error')) {
          this.showNotification({
            title: `error_file_download_title`,
            text: `error_file_download_message`,
            type: 'error',
          })
        } else {
          const url = window.URL.createObjectURL(new Blob([body]))
          let a = document.createElement('a')
          a.href = url
          a.download = `${data.fileName.replace(match[0], '')}_error.zip`
          document.body.appendChild(a)
          a.click()
          a.remove()
        }
      })
    },
    getPercentage(task) {
      const progressCount = task.processed + task.failed
      return progressCount ? (progressCount / task.rows) * 100 : 0
    },
    async getImportQueues() {
      try {
        this.importQueues = get(
          await this.$client.execute({
            operationId: 'Dynform_importProgress',
            parameters: {
              importId: this.importId,
            },
          }),
          'body',
          [],
        ).map((task) => {
          let job = {}
          job.fileName = task.originalFileName
          job.progress = this.getPercentage(task)
          job.rows = task.rows
          job.importId = task.importId
          job.successCount = task.processed
          job.failedCount = task.failed
          job.createdAt = moment(task.createdAt).format(dateTimeFormat)
          return job
        })

        this.importQueues.sort(function (a, b) {
          return new Date(b.date) - new Date(a.date)
        })
      } catch (error) {
        console.error(error)
      }
    },
  },
  destroyed() {
    clearInterval(this.intervalId)
  },
  mounted() {
    const queuePollInterval = get(window, 'CORE.env.queuePollInterval', 1000)
    this.intervalId = setInterval(this.getImportQueues, queuePollInterval)
    window.CORE.intervalTimers.push(this.intervalId)
    this.listId = this.importId
    if (!this.listId) return

    this.getImportQueues()
  },
}
</script>

<style lang="scss" scoped>
.import-queue-list {
  border: 1px solid $border-color;
  border-radius: $border-radius;
}
</style>
